export const TOGGLE_DEVICE = 'TOGGLE_DEVICE'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const EXPAND_MENU = 'EXPAND_MENU'
export const SWITCH_EFFECT = 'SWITCH_EFFECT'
export const STATE_NEW = 'STATE_NEW'
export const STATE_LOAD = 'STATE_LOAD'
export const STATE_SAVE = 'STATE_SAVE'
export const PROJECT_NAME_SET = 'PROJECT_NAME_SET'
export const ASSET_LIBRARY_ADD = 'ASSET_LIBRARY_ADD'
export const ASSET_NODE_ADD = 'ASSET_NODE_ADD'
export const ASSET_NODE_REMOVE = 'ASSET_NODE_REMOVE'
export const ASSET_NODE_UPDATE = 'ASSET_NODE_UPDATE'
export const ASSET_NODE_REMOVE_FIELD = 'ASSET_NODE_REMOVE_FIELD'
export const ASSET_NODE_ROUND = 'ASSET_NODE_ROUND'
export const ASSET_NODE_CONNECTOR_ADD = 'ASSET_NODE_CONNECTOR_ADD'
export const ASSET_NODE_CONNECTOR_REMOVE = 'ASSET_NODE_CONNECTOR_REMOVE'
export const ASSET_NODE_CONNECTOR_UPDATE = 'ASSET_NODE_CONNECTOR_UPDATE'
export const ASSET_NODE_CONNECTOR_CLEAN = 'ASSET_NODE_CONNECTOR_CLEAN'
export const ASSET_NODE_CONNECTOR_REMOVE_FIELD = 'ASSET_NODE_CONNECTOR_REMOVE_FIELD'
export const ASSET_PERSPECTIVEDISTORTION_UPDATE = 'ASSET_PERSPECTIVEDISTORTION_UPDATE'
export const PENDING_FILE_ADD = 'PENDING_FILES_ADD'
export const PENDING_FILE_REMOVE = 'PENDING_FILE_REMOVE'
export const PENDING_FILE_UPDATE = 'PENDING_FILE_UPDATE'
export const OPERATION_LIST_ADD = 'OPERATION_LIST_ADD'
export const OPERATION_LIST_REMOVE = 'OPERATION_LIST_REMOVE'
export const REDOOPERATION_LIST_ADD = 'REDOOPERATION_LIST_ADD'
export const REDOOPERATION_LIST_REMOVE = 'REDOOPERATION_LIST_REMOVE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js